export default class Star {
    constructor($dom) {
        this.dom = $dom;
        this.init();
    }

    init() {
        this.randomBlink();
    }

    randomBlink() {
        const loop = () => {
            this.dom.toggleAttribute("data-anim");
            setTimeout(loop, Math.random() > 0.5 ? 2000 : 1000);
        };

        loop();
    }
}
